const sessionStorageKeys = [
    'loginTracking',
    'projects',
    'projectDetails',
    'designs',
    'newDesign:gallery',
    'newDesign:categories',
    'categories',
    'categoryDetails',
    'collections',
    'collectionDetails',
    'download',
    'activity',
    'shared',
    'uploads',
] as const;

export type SessionStorageKey = (typeof sessionStorageKeys)[number] | `newDesign:categoryDetails:${string}`;

const filtersStorage = () => {
    const syncForUser = (userId: string) => {
        try {
            const storedUserId = sessionStorage.getItem('userId');

            if (!storedUserId) {
                sessionStorage.setItem('userId', userId);

                return;
            }

            if (storedUserId === userId) {
                return;
            }

            // remove all keys except "loginTracking"
            Object.keys(sessionStorage).forEach((key) => {
                if (key.startsWith('loginTracking')) {
                    return;
                }

                sessionStorage.removeItem(key);
            });
            sessionStorage.setItem('userId', userId);
        } catch (err) {
            console.error(err);
        }
    };

    const getFiltersFromStorage = (page: SessionStorageKey) => {
        try {
            const stored = sessionStorage.getItem(page);

            if (!stored) {
                return;
            }

            return JSON.parse(stored);
        } catch (err) {
            console.error(err);
        }
    };

    const setFiltersToStorage = (page: SessionStorageKey, value: string) => {
        try {
            sessionStorage.setItem(page, JSON.stringify(value));
        } catch (err) {
            console.error(err);
        }
    };

    const clearFiltersFromStorage = (page) => {
        try {
            sessionStorage.removeItem(page);
        } catch (err) {
            console.error(err);
        }
    };

    const clearAllFiltersFromStorage = () => {
        for (let i = 0; i < sessionStorage.length; i++) {
            const key = sessionStorage.key(i);

            if (
                key &&
                (sessionStorageKeys.includes(key as (typeof sessionStorageKeys)[number]) ||
                    key.startsWith('newDesign:categoryDetails:'))
            ) {
                sessionStorage.removeItem(key);
                i--;
            }
        }
    };

    return {
        clearAllFiltersFromStorage,
        syncForUser,
        getFiltersFromStorage,
        setFiltersToStorage,
        clearFiltersFromStorage,
    };
};

export default filtersStorage;
